import { useSyncExternalStore } from "react";

const neverChanges = () => () => undefined;

/**
 * `false` when rendering the build's document and when hydrating it, `true`
 * on every client render after that, and on the first render of a root that
 * mounts rather than hydrates.
 *
 * A server snapshot rather than an effect-set flag: React re-renders a
 * component whose server and client snapshots differ once hydration commits,
 * and a root that never hydrated skips the `false` render entirely.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    neverChanges,
    () => true,
    () => false,
  );
}
